import { fromJS } from 'immutable';

import { combineReducerArray } from '../utils/helpers';

export * from './actions';

const initialState = fromJS({});

const membershipReducerObject = {};

export default combineReducerArray(initialState, [membershipReducerObject]);
